<template>
    <v-row no-gutters justify="end">
        <v-col md="6" cols="6" class="pa-4 caption tofrom text-right">
            <div class="tofrom-caption font-weight-medium">
                {{ translations.bill_to }}
            </div>
            <div class="mt-2 title" style="margin-bottom: 12px !important">
                {{ invoice.client_name }}
            </div>
            <div class="comp-data mt-2">
                <div v-if="invoice.client_address">
                    {{ invoice.client_address }}
                </div>
                <div v-if="invoice.client_company_number">
                    {{ translations.client_company_number }}: {{ invoice.client_company_number }}
                </div>
                <div v-if="invoice.client_vat_number">
                    {{ translations.client_vat_number }}: {{ invoice.client_vat_number }}
                </div>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "InvoiceClientInfoBlock",
    components: {},
    props: {
        invoice: {
            type: Object,
            required: true
        },
        translations: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {};
    }
};
</script>

<style scoped lang="scss">
.tofrom {
    .comp-data {
        color: var(--v-g5-base);
        line-height: 20px;
    }

    .tofrom-caption {
        text-transform: uppercase;
        color: var(--v-main-base);
    }

    .tofrom-headline {
        font-size: 26px;
        letter-spacing: 0.5px;
    }
}
</style>